/**
 * Names of the sub-form fields a passenger fills to declare a lap child.
 * Stored under `${passenger}.meta.lapChild.${field}` in the passengers form.
 */
export const LAP_CHILD_FIELDS = ['firstName', 'lastName', 'documentId', 'birthDate'];

/**
 * Validation error key returned when a lap child's age is at or above the
 * configured `LAP_CHILD_MAX_AGE`. Shared between the validator (producer) and
 * the form field (consumer) so both agree on the exact sentinel value.
 */
export const LAP_CHILD_AGE_EXCEEDED_ERROR = 'lap_child_age_exceeded';

/**
 * Whether a lap-child meta object carries any user input.
 * Checks the lap-child sub-form fields (firstName, lastName, documentId, birthDate)
 * for a non-empty value.
 * Used by callers that need to distinguish between a passenger who declared
 * a lap child and one who did not.
 * @param {Object|undefined|null} lapChild - The `meta.lapChild` value to check.
 * @returns {boolean} True if any of firstName, lastName, documentId, birthDate is non-empty.
 */
export const hasLapChildData = (lapChild) =>
  Boolean(
    lapChild &&
      (lapChild.firstName || lapChild.lastName || lapChild.documentId || lapChild.birthDate),
  );
